import React, { useEffect, useState } from "react";
import SelectInput from "./../../components/common/ui/Inputs/SelectInput";
import { TextInput } from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import Table from "../../components/common/table/Table";
import { useDispatch, useSelector } from "react-redux";
import { managementUserAction } from "../../_store/managementUser.slice";
import { masterActions } from "../../_store";
import { history } from "../../_helpers";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import generateXlsx from "../../components/common/export/generateXlsx.js";
import activeIcon from "../../assets/svg/active-user.svg";
import inactiveIcon from "../../assets/svg/inactive-user.svg";
import CustomLoader from "../../components/common/ui/Loader.jsx";
import { useLocation } from "react-router-dom";
import { UserRoleName } from "../../_helpers/enumerator";
import Swal from "sweetalert2";
import AddIcon from "../../assets/svg/btn_icons/create-btn-icon.svg";
import { formatDateTimeAMPM } from "../../utils/formatTime";

function ManagementUser() {
  const { facilityDropDown: facilitydata } = useSelector(
    (state) => state.master
  );
  const [showSearchFields, setShowSearchFields] = useState(false);

  const { commonFacilityCode: facilityCode, user } = useSelector(
    (state) => state.auth
  );
  const location = useLocation();
  let sorting = false;
  const {
    managementUserList: tableData,
    managementUserFullList: exceldata,
    Role,
    managementUserInfo,
    loading,
    managementUserSearchData,
  } = useSelector((state) => state.managementUser);

  const isPageReloading = useSelector((state) => state.master?.isPageReload);
  const [isLoading, setIsLoading] = useState(false);

  const { managementUserStatus } = useSelector(
    (state) => state.dropdownOptions
  );

  // Replace first object label
  const updatedRole = Role.map((role, index) => {
    if (index === 0) {
      return { ...role, label: "-- ALL --" }; // Replace the label of the first object
    }
    return role;
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (facilityCode === 0) return;
    dispatch(managementUserAction.GetUserRole());
  }, [facilityCode]);

  // Update managementUserSearchData state when facilityCode changes
  useEffect(() => {
    if (facilityCode) {
      let updatedState = { ...managementUserSearchData };
      updatedState.facilityID = facilityCode;
      updatedState.accessBy = user?.ManagementUserID;
      updatedState.loggedInUserRoleID = user?.UserRoleID;
      dispatch(managementUserAction?.setManagementUserSearchData(updatedState));
    }
  }, [facilityCode]);

  // Dispatch the action when facilityID changes in loadManagementUser
  useEffect(() => {
    if (facilityCode) {
      setIsLoading(true);
      dispatch(managementUserAction.LoadManagementUserList({
        ...managementUserSearchData,
        facilityID: facilityCode,
        accessBy: user?.ManagementUserID,
        loggedInUserRoleID: user?.UserRoleID,
      })
      )
        .then((result) => {
          setIsLoading(false);
          if (result?.payload?.DataList?.length === 0) {
            const searchParams = { ...managementUserSearchData };
            searchParams.pageNo = 1;
            searchParams.rowCountPerPage = 10;
            searchParams.facilityID = facilityCode;
            searchParams.accessBy = user?.ManagementUserID;
            searchParams.loggedInUserRoleID = user?.UserRoleID;
            dispatch(
              managementUserAction?.setManagementUserSearchData(searchParams)
            );
            dispatch(managementUserAction.LoadManagementUserList(searchParams));
          }
        })
        .catch((err) => { });
    }
  }, [
    isPageReloading,
    facilityCode,
  ]);

  const formatDate = (date) => {
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };

    const formatter = new Intl.DateTimeFormat("en-US", options);
    const formattedDate = formatter.format(new Date(date));
    return formattedDate.replace(",", "");
  };

  //Column For Table
  const columns = [
    {
      name: "Full Name",
      key: "FullName",
      selector: (row) => row.FullName,
      sortable: true,
      cell: (row) => (
        <div
          className="Common_Link_Style "
          onClick={() => handleManagementUserInfo(row)}
        >
          {row.FullName}
        </div>
      ),
    },
    {
      name: "Username",
      key: "UserName",
      selector: (row) => row.UserName,
      sortable: true,
    },
    {
      name: "Role",
      key: "UserRoleName",
      selector: (row) => row.UserRoleName,
      sortable: true,
    },
    {
      name: "Last Login Date",
      key: "LastLoginDate",
      selector: (row) =>
        row.LastLoginDate ? formatDate(row.LastLoginDate) : "-",
      sortable: true,
    },
    {
      name: "Status",
      key: "ActiveStatus",
      selector: (row) => row.ActiveStatus,
      cell: (row) => (
        <div className="d-flex flex-wrap h-100">
          <img
            title={row.ActiveStatus === "Active" ? "Active" : "Inactive"}
            src={row.ActiveStatus === "Active" ? activeIcon : inactiveIcon}
            alt={
              row.ActiveStatus === "Active" ? "Active User" : "Inactive User"
            }
            style={{ width: "20px", height: "20px" }} // Adjust icon size as needed inactiveIcon
          />
        </div>
      ),
      sortable: true,
      // center: true,
    },
  ];

  const handleManagementUserInfo = (row) => {
    Swal?.close();
    dispatch(managementUserAction.resetForm());
    dispatch(managementUserAction.resetMenuList());
    history.navigate("/Admin/ManagementUserList/Edit", {
      state: {
        id: row.ManagementUserID,
      },
    });
  };

  //Set the Values of handleChange

  const handleChange = (e) => {
    let { name, value } = e?.target;

    // If the field is "ZIP", allow only numeric input
    let updatedValue = value.trim();

    switch (name) {
      case "ZIP":
        // Ensure only digits are allowed for ZIP field
        updatedValue = value.replace(/\D/g, "");
        break;
      case "Username":
        // Username field doesn't accept special characters or spaces between letters
        updatedValue = value.replace(/[^a-zA-Z0-9]/g, "");
        break;
      case "City":
        // City field doesn't accept special characters or spaces between letters or numbers
        // updatedValue = value.replace(/[^a-zA-Z]/g, "");
        updatedValue = value;
        break;
      case "FullName":
        // All other fields: Remove special characters but accept spaces
        updatedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
        break;
      default:
        // All other fields: Remove special characters but accept spaces
        updatedValue = value;
        break;
    }
    let updatedState = { ...managementUserSearchData };
    updatedState[name] = updatedValue;
    dispatch(managementUserAction?.setManagementUserSearchData(updatedState));
  };

  const handleSelectChange = (selectedOption, name) => {
    let updatedParams = {
      ...managementUserSearchData,
      pageNo: 1,
      rowCountPerPage: 10,
    };
    const defaultValue = 2; // Default value for null or undefined values

    // Helper function to update state and params
    const updateManagementUserData = (value) => {
      updatedParams[name] =
        name === "ActiveStatus"
          ? parseInt(value ?? defaultValue, 10) // Parse value or fallback to default
          : value ?? 0;
      dispatch(
        managementUserAction?.setManagementUserSearchData(updatedParams)
      );
    };

    // Call helper function with selectedOption value for the relevant names
    if (name === "ActiveStatus" || name === "UserRoleID") {
      updateManagementUserData(selectedOption?.value);
    }

    // Dispatch action if facilityCode exists
    if (facilityCode) {
      dispatch(managementUserAction.LoadManagementUserList(updatedParams));
      dispatch(
        managementUserAction?.setManagementUserSearchData(updatedParams)
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check if a facilityCode is selected
    if (facilityCode) {
      // Check if any search field has a value before submitting the form
      if (
        managementUserSearchData?.Username ||
        managementUserSearchData?.FullName ||
        managementUserSearchData?.UserRoleID ||
        managementUserSearchData?.City ||
        managementUserSearchData?.ZIP ||
        managementUserSearchData?.ActiveStatus
      ) {
        // Dispatch the action to load the management user list with the search criteria
        let updatedState = { ...managementUserSearchData };
        updatedState.facilityID = facilityCode;
        updatedState.pageNo = 1;
        updatedState.rowCountPerPage = 10;
        updatedState.accessBy = user?.ManagementUserID;
        updatedState.loggedInUserRoleID = user?.UserRoleID;
        dispatch(
          managementUserAction?.setManagementUserSearchData(updatedState)
        );
        dispatch(managementUserAction.LoadManagementUserList(updatedState));
      }
    }
  };

  const handleReset = () => {
    // Define the default state values for reset
    const resetState = {
      loggedInUserRoleID: user?.UserRoleID,
      facilityID: facilityCode, // Using the facilityCode from the current state
      Username: "",
      FullName: "",
      UserRoleID: 0,
      City: "",
      ZIP: "",
      ActiveStatus: 2,
      pageNo: 1,
      rowCountPerPage: 10,
      sortBy: "",
      accessBy: user?.ManagementUserID,
    };

    // Set the state with reset values
    dispatch(managementUserAction?.setManagementUserSearchData(resetState));

    // Dispatch the action with the updated reset state
    if (facilityCode) {
      dispatch(managementUserAction.LoadManagementUserList(resetState));
    }
  };

  const addUser = () => {
    Swal?.close();
    dispatch(managementUserAction.resetForm());
    history.navigate("ManagementUserList/Add", {
      state: {
        id: 0,
      },
    });
  };

  //For Excel and PDF

  useEffect(() => {
    if (exceldata && exceldata?.DataList?.length > 0) {
      let title = "AdminUsers_List";
      let generateExcelColumns = [
        "Full Name",
        "Username",
        "Role",
        "Last Login Date",
        "Status",
      ];

      // Map the account manager list to match the Excel format
      let adminUsers_List =
        exceldata?.DataList?.map((obj) => ({
          FullName: obj.FullName,
          Username: obj.UserName,
          Role: UserRoleName[obj.UserRoleID],
          LastLoginDate: formatDateTimeAMPM(obj.LastLoginDate),
          Status: obj.ActiveStatus,
        })) || [];

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(adminUsers_List, generateExcelColumns, title);

        // Clear excel data after the download
        dispatch(managementUserAction.clearmanagementUserFullList());
      } catch (error) {
        // Handle any errors that occur during Excel generation
        console.error("Error generating Excel file:", error);
      }
    }
  }, [exceldata]);

  const handleClickExcel = () => {
    // Define the title and column headers for the Excel file
    const updateTotalRows = {
      ...managementUserSearchData,
      PageNo: 1,
      rowCountPerPage: tableData?.TotalRecordCount,
      exportExcel: true, // Flag to indicate Excel export
      // sortBy : managementUserSearchData.sortBy.endsWith("asc")
      // ? managementUserSearchData.sortBy.replace("asc","desc")
      // : managementUserSearchData.sortBy.replace("desc","asc")
    };

    dispatch(managementUserAction.LoadManagementUserList(updateTotalRows));
  };

  //Pagination
  const handlePageChange = (value) => {
    if (sorting) {
      sorting = false;
      return;
    }
    let updatedState = { ...managementUserSearchData };
    updatedState.pageNo = value;
    dispatch(managementUserAction?.setManagementUserSearchData(updatedState));
    dispatch(managementUserAction.LoadManagementUserList({
      ...managementUserSearchData,
      pageNo: value,
      accessBy: user?.ManagementUserID,
      loggedInUserRoleID: user?.UserRoleID,
    })
    )
  }; // Call API when page changes
  const handleRowPerPage = (value) => {
    let updatedState = { ...managementUserSearchData };
    updatedState.rowCountPerPage = value;
    updatedState.pageNo = 1;
    dispatch(managementUserAction?.setManagementUserSearchData(updatedState));
    dispatch(managementUserAction.LoadManagementUserList({
      ...managementUserSearchData,
      pageNo: 1,
      rowCountPerPage: value,
      accessBy: user?.ManagementUserID,
      loggedInUserRoleID: user?.UserRoleID,
    })
    )
  };

  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    let updatedState = { ...managementUserSearchData };
    updatedState.facilityID = facilityCode;
    updatedState.accessBy = user?.ManagementUserID;
    updatedState.loggedInUserRoleID = user?.UserRoleID;
    const newSortOrder = updatedState.sortBy.includes(column.key)
      ? updatedState.sortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    //updatedState.sortBy = `${column.key} ${sortDirection}`;
    updatedState.sortBy = `${column.key} ${newSortOrder}`;
    dispatch(managementUserAction?.setManagementUserSearchData(updatedState));

    dispatch(
      managementUserAction.LoadManagementUserList({
        ...managementUserSearchData,
        facilityID: facilityCode,
        sortBy: `${column.key} ${newSortOrder}`,
      })
    );
  };

  if (loading || isLoading) {
    return <CustomLoader />;
  }

  const renderSearch = () => {
    return (
      <form onSubmit={handleSubmit}>
        {/* First Row: Username, Last Name, First Name */}
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="Username"
                id="Username"
                label="Username"
                value={managementUserSearchData.Username}
                handleChange={handleChange}
                placeholder="Username"
                required={false}
                maxLength={50}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="FullName"
                id="FullName"
                label="Full Name"
                value={managementUserSearchData.FullName}
                handleChange={handleChange}
                placeholder="Full Name"
                required={false}
                maxLength={50}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                options={updatedRole}
                value={managementUserSearchData.UserRoleID}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "UserRoleID")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={managementUserSearchData.UserRoleID !== 0}
                placeholder="Select Role"
                label="Role"
              />
            </div>
          </div>

          {/* Second Row: City and ZIP */}
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="City"
                id="City"
                label="City"
                value={managementUserSearchData.City}
                handleChange={handleChange}
                placeholder="City"
                required={false}
                maxLength={25}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                type="text"
                name="ZIP"
                id="ZIP"
                label="ZIP"
                value={managementUserSearchData.ZIP}
                handleChange={handleChange}
                placeholder="ZIP"
                required={false}
                maxLength={5}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              {/* Status */}
              <SelectInput
                options={managementUserStatus}
                value={
                  managementUserSearchData.ActiveStatus ||
                    managementUserSearchData.ActiveStatus === 0
                    ? managementUserSearchData.ActiveStatus
                    : 2
                }
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "ActiveStatus")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={managementUserSearchData.ActiveStatus !== 2}
                placeholder="--ALL--"
                label="Status"
                defaultValue={2}
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
          <Button
            variant="primary"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          />
          <Button
            variant="secondary"
            className="me-2"
            onClick={handleReset}
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  return (
    <div>
      {/* First Card: Form and Buttons */}
      {facilityCode ? (
        <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
          <div className="card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 w-100 ">
            <div className="row align-items-center">
              {/* <div className="col-md-8 mb-2">
                <h2 className="form_title_uppercase text-color">USER SEARCH</h2>
              </div> */}
              {/*  <div className="col-sm-12 col-md-6 col-lg-4">
              <div className="form-floating mb-3">
                <SelectInput
                  name="facilityCode"
                  label="Facility Code"
                  options={facilitydata}
                  value={facilityCode}
                  isMulti={false}
                  handleChange={hadleFacilityChange}
                />
              </div>
            </div> */}

              {/* Mobile only (Below md breakpoint) */}
              <div className=" d-block d-md-none">
                <div
                  className=" d-flex align-items-center justify-content-between"
                  style={{ background: "transparent", cursor: "pointer" }}
                  onClick={toggleInformation}
                >
                  <h2 className="form_title_uppercase text-color">
                    USER SEARCH
                  </h2>
                  <i
                    id="itagInformation"
                    className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                      }`}
                    style={{ fontSize: "20px" }}
                  ></i>
                </div>
              </div>
              {/* Mobile only (Below md breakpoint) */}
              <div className="d-block d-md-none">
                {showSearchFields && renderSearch()}
              </div>

              {/* Web only (Desktop and above) */}
              <div className="mb-3 d-none d-md-block">
                <h2 className="form_title_uppercase text-color">USER SEARCH</h2>
              </div>
              {/* Web only (Desktop and above) */}
              <div className="d-none d-md-block">{renderSearch()}</div>
            </div>

            <></>
          </div>
        </div>
      ) : (
        <h4 className="facility-card">Select a Facility Code from the list</h4>
      )}

      {/* Second Card: Table and Export Button */}
      {facilityCode ? (
        <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 resp-space">
              <h2 className="form_title_uppercase text-color">USERS LIST</h2>
              <div className="d-flex flex-wrap gap-3 align-items-center">
                <Button
                  variant="success"
                  className="me-2"
                  onClick={addUser}
                  label="Add User"
                  type="button"
                  status="btn-label"
                  disabled={false}
                  //icon={"circle-plus"}
                  imgsrc={AddIcon}
                />
                {tableData?.DataList?.length > 0 && (
                  <ExcelExport handleExcelExport={handleClickExcel} />
                )}
              </div>
            </div>
            <Table
              title={""}
              columns={columns}
              data={tableData?.DataList}
              pagination
              onChangeRowsPerPage={handleRowPerPage}
              onChangePage={handlePageChange}
              totalRowCount={tableData?.TotalRecordCount}
              currentPage={managementUserSearchData?.pageNo}
              paginationPerPage={managementUserSearchData.rowCountPerPage}
              onSort={handleSort}
              serverSideSort
              sortColumn={managementUserSearchData.sortBy.split(" ")[0]}
              sortDirection={managementUserSearchData.sortBy.split(" ")[1]}
            />
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default React.memo(ManagementUser);
